import { ViewModel,View, ObservableArray } from "binder"
import  { PricingPerCarModelView } from "./pricingPerCarModel-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { AutomatedPriceUpdatingViewModel } from "../AutomatedPriceUpdating/automatedPriceUpdating-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class PricingPerCarModelViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'تنظیم قیمت';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.carModelList = ObservableArray.create<carModelForTab>();
        this.pricesPerCarModel = ObservableArray.create<AutomatedPriceUpdatingViewModel>();
        this.start();
    }
    GetDefaultView(): View <ViewModel> {
        return new PricingPerCarModelView();
    }
    public getTypeId(): string {
        return "VM-B6A93A46-3AB5-4ED4-B899-2DA9C4582BC9"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set shallShowPopup(v: boolean) { this._shallShowPopup = v; } public get shallShowPopup(): boolean { return this._shallShowPopup;} private _shallShowPopup: boolean;
    public set carModelList(v: ObservableArray<carModelForTab>) { this._carModelList = v; } public get carModelList(): ObservableArray<carModelForTab> { return this._carModelList;} private _carModelList: ObservableArray<carModelForTab>;
    public set pricesPerCarModel(v: ObservableArray<AutomatedPriceUpdatingViewModel>) { this._pricesPerCarModel = v; } public get pricesPerCarModel(): ObservableArray<AutomatedPriceUpdatingViewModel> { return this._pricesPerCarModel;} private _pricesPerCarModel: ObservableArray<AutomatedPriceUpdatingViewModel>;
    public set selectedPricingCarModel(v: AutomatedPriceUpdatingViewModel) { this._selectedPricingCarModel = v; } public get selectedPricingCarModel(): AutomatedPriceUpdatingViewModel { return this._selectedPricingCarModel;} private _selectedPricingCarModel: AutomatedPriceUpdatingViewModel;
    
    async refresh(): Promise<any> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllCarBrand',{});
        this.carModelList.update(...result.CarBrand.map(q=>{
            let result = new carModelForTab(this);
            result.id = q.Id;
            result.carName = q.Name;
            return result;
        }));
    }
    async start(){
        await this.refresh();
        await this.createTabs();
    }
    
    createTabs() {
        this.pricesPerCarModel.update(...this.carModelList.map(car => {
            let pricePerCar = new AutomatedPriceUpdatingViewModel(this);
            pricePerCar.car = car.id;
            pricePerCar.carName = car.carName;
            pricePerCar.tabName = car.carName;
            return pricePerCar;
        }));
        let pricePerCar = new AutomatedPriceUpdatingViewModel(this);
            pricePerCar.car = null;
            pricePerCar.carName = "همه کالاها";
            pricePerCar.tabName = "همه کالاها";
            pricePerCar.isAdmin = false;
            this.pricesPerCarModel.push(pricePerCar);
        setTimeout(()=>{
            this.selectedPricingCarModel = this.pricesPerCarModel[0];
        },500);
    }

    closePopup() {
        this.shallShowPopup = false;
    }
    showPopup2(vm:ViewModel,a?,b?){
        this.popup = <any>vm;
        this.shallShowPopup = true;
    }
    
}

class carModelForTab extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);   
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set carName(v: string) { this._carName = v; } public get carName(): string { return this._carName;} private _carName: string;
}
